module.exports = __webpack_public_path__ + "static/como-funciona-integracao-357bdffefa66257d044afd45aa4a4820.svg";